<template>
    <div class="mobile-game-menu">
        <div class="menu-option timeout-wrapper-mobile" @click="onToggleShowTimeout" v-if="!isBlitzMode">
            <fa-icon icon="hourglass" />
            <timeout-mobile v-show="showTimeout" :refresh="refreshTimeout" />
        </div>
        <div class="menu-option undo-wrapper-mobile" @click="onUndoCallback">
            <fa-icon icon="undo-alt" />
        </div>
        <div class="menu-option forfeit-wrapper-mobile" @click="onForfeitGame">
            <fa-icon class="flag-icon" icon="flag" />
        </div>
        <div class="menu-option sound-wrapper-mobile">
            <sound />
        </div>
        <div class="menu-option rules-wrapper-mobile" @click="onShowRulesModal">
            <fa-icon class="rules-icon" icon="scroll" />
        </div>
        <div class="menu-option chat-wrapper-mobile" @click="onShowChat">
            <div class="chat-wrapper-mobile-inner">
                <fa-icon class="chat-icon" icon="comment"/>
                <span class="unread-messages-count" v-if="unreadMessagesCount">
                    {{ unreadMessagesCount > 9 ? '9+' : unreadMessagesCount }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: [
        'onUndoCallback',
        'refreshTimeout',
        'gameId',
    ],
    name: 'MobileGameMenu',
    data() {
        return {
            showTimeout: false,
        };
    },
    computed: {
        chatState() {
            return this.$store.state.chatState;
        },
        messages() {
            return this.chatState.messages;
        },
        readMessages() {
            return this.chatState.readMessages;
        },
        unreadMessagesCount() {
            return this.messages.length - this.readMessages.length;
        },
        isBlitzMode() {
            return this.$store.state.gameState.blitz;
        },
    },
    methods: {
        onForfeitGame() {
            this.$store.dispatch('openModal', {
                type: 'leaveGame',
                data: {
                    gameId: this.gameId,
                },
            });
        },
        onShowChat() {
            this.$store.dispatch('setShowChat', true);
        },
        onShowRulesModal() {
            if (this.$store.state.modalState.modals['rules'].show) {
                this.$store.dispatch('closeModal', 'rules');
            } else {
                this.$store.dispatch('openModal', { type: 'rules' });
            }
        },
        onToggleShowTimeout() {
            this.showTimeout = !this.showTimeout;
        },
    },
};
</script>

<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;

    .mobile-game-menu {
        background: white;
        box-shadow: 0px -1px 2px 1px rgba(181, 181, 181, .5);
        box-sizing: border-box;
        color: $sage-brown;
        display: flex;
        width: 100%;
        z-index: 10;
        justify-content: space-between;

        > * {
            cursor: pointer;
            position: relative;
        }

        .menu-option {
            padding: 10px 0;
            height: 100%;
            flex-grow: 1;

            &.chat-wrapper-mobile {

                .chat-wrapper-mobile-inner {
                    position: relative;

                    .chat-icon {
                        font-size: 1.15em;
                    }

                    .unread-messages-count {
                        background: $teal;
                        border-radius: 50%;
                        color: white;
                        display: inline-block;
                        font-size: .7em;
                        height: 12px;
                        line-height: 12px;
                        padding: 1.75px;
                        position: absolute;
                        left: 50%;
                        top: -6px;
                        vertical-align: middle;
                        width: 12px;
                    }
                }
            }

            &.sound-wrapper-mobile {
                padding: 9px 0;
            }

            &.timeout-wrapper-mobile {

                .timeout-mobile-wrapper {
                    position: absolute;
                    top: -40px;
                    left: 10px;
                }
            }
        }
    }

    @media only screen and (min-width: $screen-xs) {

        .mobile-game-menu {
            display: none;
        }
    }

</style>
